import {toast} from "react-toastify";

const OpsToast = (
    content = "",
    type = "default",
    theme = "light",
    hideProgressBar = false,
    position = "bottom-right",
    autoClose = 3000,
    closeOnClick = true,
    pauseOnHover = true,
    draggable = true
) => {

    let customOptions = {
        position: position,
        autoClose: autoClose,
        hideProgressBar: hideProgressBar,
        closeOnClick: closeOnClick,
        pauseOnHover: pauseOnHover,
        draggable: draggable,
        progress: undefined,
        theme: theme,
    }


    if (type === "success")
        return toast.success(content, customOptions);

    else if (type === "error")
        return toast.error(content, customOptions);

    else if (type === "info")
        return toast.info(content, customOptions);

    else if (type === "warning")
        return toast.warning(content, customOptions);

    return toast(content, customOptions);
};

export default OpsToast;